const channels = [
  {
    id: 1,
    name: 'English Easy Practice',
    url: 'https://www.youtube.com/@EnglishEasyPractice',
    videos: [
      'https://www.youtube.com/watch?v=-qdm2VWEADs'
    ]
  }
]

export default channels


// WEBPACK FOOTER //
// ./src/browser/channels/languages/english.js